import { SideBar } from '@/components/features/layout/Navigation/components/Sidebar';
import { useIsMobile } from '@/hooks/useIsMobile';
import MobileNavBar from './components/MobileNavBar/MobileNavBar';

interface Props {
  isMenuMinify: boolean;
  isOpenSideBar: boolean;
  setIsOpenSideBar: (isOpen: boolean) => void;
  isHomePage: boolean;
  hideMobileNav?: boolean;
}

const Navigation = ({ isMenuMinify, isOpenSideBar, setIsOpenSideBar, isHomePage, hideMobileNav }: Props) => {
  const handleOpenSideBar = () => {
    return setIsOpenSideBar(!isOpenSideBar);
  };

  const handleCloseSideBar = () => {
    return setIsOpenSideBar(false);
  };

  const isMobile = useIsMobile();

  return (
    <>
      <SideBar
        isHomePage={isHomePage}
        isOpenSideBar={isOpenSideBar}
        handleCloseSideBar={handleCloseSideBar}
        isMobile={isMobile}
        isMenuMinify={!isMobile && isMenuMinify}
      />
      {!hideMobileNav && <MobileNavBar handleOpenSideBar={handleOpenSideBar} isOpenSideBar={isOpenSideBar} handleCloseSideBar={handleCloseSideBar} />}
    </>
  );
};

Navigation.displayName = 'Navigation';

export default Navigation;
